/* PDP bundle — "Combineer & krijg korting".
   Voegt de gekozen maat van de hoofdsneaker + aangevinkte add-ons in één keer
   toe via /cart/add.js, en ververst daarna de cart-drawer exact zoals het
   thema dat zelf doet (?section_id=helper-cart → #AjaxCartForm swap).
   De getoonde korting is weergave; de echte korting rekent de checkout af
   via de automatische korting in de admin. */

(function () {
  if (customElements.get('pdp-bundle')) return;

  const money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  const fmt = (cents) => money.format(cents / 100);

  class PdpBundle extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode || 'product';
      this.pct = parseInt(this.dataset.discountPct, 10) || 0;
      this.mainPrice = parseInt(this.dataset.mainPrice, 10) || 0;
      this.productPage = document.querySelector('[data-js-product-component]');
      this.button = this.querySelector('[data-bundle-add]');
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.savingsWrap = this.querySelector('[data-bundle-savings]');
      this.savingsEl = this.querySelector('[data-bundle-savings-amount]');
      this.sizeHint = this.querySelector('[data-bundle-size-hint]');

      this.querySelectorAll('[data-bundle-item]').forEach((cb) =>
        cb.addEventListener('change', () => this.render())
      );
      // varianten-dropdown (bv. veters-maat): keuze stuurt variant-id + prijs
      // van het item, en werkt de getoonde prijzen + totalen bij
      this.querySelectorAll('[data-bundle-variant-select]').forEach((sel) =>
        sel.addEventListener('change', () => {
          const item = sel.closest('.pdp-bundle__item');
          const cb = item.querySelector('[data-bundle-item]');
          const opt = sel.selectedOptions[0];
          cb.dataset.variantId = opt.value;
          cb.dataset.price = opt.dataset.price;
          const price = parseInt(opt.dataset.price, 10);
          const was = item.querySelector('.pdp-bundle__was');
          const now = item.querySelector('.pdp-bundle__now');
          if (was) was.textContent = fmt(price);
          if (now) now.textContent = fmt(Math.round((price * (100 - this.pct)) / 100));
          this.render();
        })
      );
      this.button.addEventListener('click', () => this.addToCart());

      // maatkeuze in de koopsectie volgen (bestaand thema-event)
      document.addEventListener('krown:variant:change', () => this.render());
      this.render();
    }

    mainVariantId() {
      const input = this.productPage && this.productPage.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    sizeChosen() {
      if (this.mode === 'cart') return true;
      return this.productPage && this.productPage.classList.contains('variant-selected');
    }

    checkedItems() {
      return [...this.querySelectorAll('[data-bundle-item]:checked')];
    }

    render() {
      const items = this.checkedItems();
      const addonsTotal = items.reduce((s, cb) => s + parseInt(cb.dataset.price, 10), 0);
      const discounted = Math.round((addonsTotal * (100 - this.pct)) / 100);
      const savings = addonsTotal - discounted;

      this.totalEl.textContent = ' ' + fmt(this.mainPrice + discounted);
      if (savings > 0) {
        this.savingsEl.textContent = fmt(savings);
        this.savingsWrap.hidden = false;
      } else {
        this.savingsWrap.hidden = true;
      }

      // cart-modus: knop pas actief als er iets aangevinkt is (er is geen
      // hoofdproduct om toe te voegen); product-modus: actief zodra maat gekozen
      const ready = this.mode === 'cart' ? items.length > 0 : this.sizeChosen();
      this.button.disabled = !ready;
      if (this.sizeHint) this.sizeHint.hidden = this.sizeChosen();
    }

    async addToCart() {
      const items = this.checkedItems().map((cb) => ({
        id: parseInt(cb.dataset.variantId, 10),
        quantity: 1,
      }));

      if (this.mode === 'product') {
        const mainId = this.mainVariantId();
        if (!mainId || !this.sizeChosen()) return;
        items.unshift({ id: parseInt(mainId, 10), quantity: 1 });
      } else if (items.length === 0) {
        return;
      }

      this.button.classList.add('loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('add failed');
        await this.refreshCart();
      } catch (e) {
        console.error('Error', e);
      }
      this.button.classList.remove('loading');
    }

    async refreshCart() {
      // zelfde verversing als het thema (component-product-form.js)
      const res = await fetch('?section_id=helper-cart');
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');

      const form = document.getElementById('AjaxCartForm');
      const subtotal = document.getElementById('AjaxCartSubtotal');
      if (form && html.getElementById('AjaxCartForm')) {
        form.innerHTML = html.getElementById('AjaxCartForm').innerHTML;
        if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
      }
      if (subtotal && html.getElementById('AjaxCartSubtotal')) {
        subtotal.innerHTML = html.getElementById('AjaxCartSubtotal').innerHTML;
      }
      document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
        const c = html.querySelector('[data-cart-count]');
        if (c) el.textContent = c.textContent;
      });
      document.querySelectorAll('[data-header-cart-total]').forEach((el) => {
        const t = html.querySelector('[data-cart-total]');
        if (t) el.textContent = t.textContent;
      });

      const drawer = document.querySelector('[data-js-site-cart-sidebar]');
      if (drawer && typeof drawer.show === 'function') drawer.show();

      // laat o.a. de free-shipping-meters live bijrekenen
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  customElements.define('pdp-bundle', PdpBundle);
})();
